// extracted by mini-css-extract-plugin
export default {"base":"FileSearch_base__v8skQ","filenameContainer":"FileSearch_filenameContainer__Kkj8N","deleteFile":"FileSearch_deleteFile__AsJMX","actions":"FileSearch_actions__hzxNg"};